module.exports = __webpack_public_path__ + "media/new_passenger_registered.90a6d5af.mp3";